export const OVERLAPPED_DOCUMENT = 409;
export const QR_CODE_NOT_FOUND = 404;
